import { axios } from '@Api/axiosClient';

const baseUrl: string = 'api/ActivitySession';

export const verifyUserApi = async (): Promise<string> => {
    const response = await axios.get(`${baseUrl}/VerifyUser`);
    return response ? response.data : '';
};

export const addRequestDetailsToActivitySessionByRecipientTokenApi = async (recipientToken: string): Promise<void> => {
    await axios.post(`${baseUrl}/AddRequestDetailsToActivitySessionByRecipientToken`, recipientToken);
};

export const getRecipientTokenByActivitySessionApi = async (): Promise<string> => {
    const response = await axios.get(`${baseUrl}/GetRecipientTokenByActivitySession`);
    return response ? response.data : '';
};
